export class FileUpload {
  types = [
    'Monthly Statement',
    'Staitment Analysis',
    'Cost Analysis',
    'Proposal',
    'Agreement',
    'Agreement - Signed',
    'Other',
  ];

  file: File;
  type: string | undefined;
  otherType: string | undefined;
  notes: string | undefined;

  constructor(a: Partial<FileUpload>) {
    if (a.file == null)
      throw new Error(
        `Invalid attachment in constructor: ${JSON.stringify(a)} file cannot be null`,
      );
    //if (a.type == null)
    //    throw new Error(`Invalid attachment in constructor: ${JSON.stringify(a)} type cannot be null`);
    //if (a.type == "Other" && a.otherType == null || a.otherType?.trim() == "")
    //    throw new Error(`Invalid attachment in constructor: ${JSON.stringify(a)} other type cannot be null with type is Other`);

    this.file = a.file;
    this.type = a.type;
    this.otherType = a.otherType;
    this.notes = a.notes;
  }
}
